import React, { useContext, useEffect, useState } from "react";

import { AuthContext } from "../services/AuthContext";
import { useNavigate } from "react-router-dom";
import CreatePostForm from "./components/CreatePostForm";
import GetPostForm from "./components/GetPostForm";
import Menu from "./components/Menu";
import axios from "axios";

function Home() {
  const [menu, setMenu] = useState("show");

  const navigate = useNavigate();
  const { login, setLogin } = useContext(AuthContext);

  const onLogOut = () => {
    localStorage.removeItem("AuthToken");
    navigate("/entry");
    setLogin(false);
  };

  return (
    <div style={{ color: "white" }}>
      <Menu
        setMenu={(value) => setMenu(value)}
        menu={menu}
        onLogOut={onLogOut}
      />

      {menu == "show" ? <GetPostForm /> : <CreatePostForm />}

      <div></div>
    </div>
  );
}

export default Home;
